import { Box } from 'theme-ui';

import { Markdown } from '@snippets';

import { themed } from './Content.theme';

export const Content = themed(({ body, bodyHtml, theme }) => {
  return (
    <Box variant="layout.padded" sx={theme.wrapper}>
      <Box sx={theme.body}>
        {bodyHtml ? (
          <Box sx={theme.html} dangerouslySetInnerHTML={{ __html: bodyHtml }} />
        ) : (
          <Markdown textSx={theme.markdown} text={body} />
        )}
      </Box>
    </Box>
  );
});
